import { render, staticRenderFns } from "./visitDetails.vue?vue&type=template&id=6561bae5&scoped=true"
import script from "./visitDetails.vue?vue&type=script&lang=js"
export * from "./visitDetails.vue?vue&type=script&lang=js"
import style0 from "./visitDetails.vue?vue&type=style&index=0&id=6561bae5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561bae5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6561bae5')) {
      api.createRecord('6561bae5', component.options)
    } else {
      api.reload('6561bae5', component.options)
    }
    module.hot.accept("./visitDetails.vue?vue&type=template&id=6561bae5&scoped=true", function () {
      api.rerender('6561bae5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/visitRecords/visitDetails.vue"
export default component.exports